import { Box, Theme, Typography, useTheme } from "@mui/material";
import React, { Ref, useState } from "react";
import styled from "styled-components";

import { prefixClassName } from "@smartrr/shared/components/primitives";
import { ICustomerPortalTheme } from "../../entities/CustomerPortalTheme";

interface Props {
  maxLength?: number;
  ref?: Ref<HTMLTextAreaElement | null>;
  placeholder?: string;
  defaultValue?: string | undefined;
  value?: string;
  onChange?: React.ChangeEventHandler<HTMLTextAreaElement> | undefined;
}
const StyledBox = styled(Box)`
  position: relative;
  & p {
    bottom: 15px;
    color: rgba(32, 34, 35, 0.5);
    position: absolute;
    right: 10.5px;
  }
`;
const StyledTextArea = styled.textarea.attrs(() => ({
  className: prefixClassName("textarea"),
}))<{ aquariusTheme: Theme & ICustomerPortalTheme }>`
  border: 1px solid ${props => props.aquariusTheme.modernSecondaryButtonBorderColor};
  border-radius: 8px;
  height: 150px;
  padding: 10px 18px;
  font-family: ${props => props.aquariusTheme.modernBodyFontFamily};
  font-size: ${props => props.aquariusTheme.modernBodyFontSize}px;
  font-weight: ${props => props.aquariusTheme.modernBodyFontWeight};
  line-height: ${props => props.aquariusTheme.modernBodyFontLineHeight}px;
  letter-spacing: ${props => props.aquariusTheme.modernBodyFontLetterSpacing};
  text-align: left;
  width: 100%;
  resize: none;
`;

export const AquariusTextarea = React.forwardRef<HTMLTextAreaElement, Props>(
  ({ maxLength, placeholder, defaultValue, value, onChange, ...props }: Props, ref): React.JSX.Element => {
    const [count, setCount] = useState(0);
    const handleChange = (e: React.ChangeEvent<HTMLTextAreaElement>) => {
      setCount(e.target.value.length);
      onChange?.(e);
    };

    return (
      <StyledBox>
        <StyledTextArea
          aquariusTheme={useTheme()}
          value={value}
          defaultValue={defaultValue}
          // ref type issue that TS won't acknowledge as resolved
          //@ts-ignore
          ref={(ref as React.RefObject<HTMLTextAreaElement>)!}
          maxLength={maxLength}
          placeholder={placeholder}
          onChange={(e: any) => handleChange(e)}
          {...props}
        />
        {!!maxLength && (
          <Typography variant="body1">
            {count}/{maxLength}
          </Typography>
        )}
      </StyledBox>
    );
  }
);
